export function addClassName(className, props) {
  if('className' in props) {
    props.className = `${className} ${props.className}`
  } else {
    props.className = className
  }
  return props
}